"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _react = require("react");

var _useAssetData = _interopRequireDefault(require("./useAssetData"));

var _useCapabilities = _interopRequireDefault(require("./useCapabilities"));

var _useGlobalCommentsToggle = _interopRequireDefault(require("./useGlobalCommentsToggle"));

var _useIMSData = _interopRequireDefault(require("./useIMSData"));

var _useOfflineStatus = _interopRequireDefault(require("./useOfflineStatus"));

var _usePrevious = _interopRequireDefault(require("./usePrevious"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var appContextKeys = ['analyticsDebounce', 'analyticsData', 'appKey', 'appName', 'authenticateFetch', 'annotationsCreationEnabled', 'backgroundModeEnabled', 'cacheComments', 'compactLayout', 'disableCCXWorkflow', 'disableNetworkIndicator', 'environment', 'globalComments', 'peopleGraphAPIKey', 'hasReviewAccess', 'inContextCommentingEnabled', 'isMapping', 'isLoading', 'invitationServiceAccessToken', 'localeStringOverrides', 'reviewType', 'richTextEntry', 'shareStatus', 'spectrumUIScale', 'theme', 'annotationsEnabled', 'annotationsMultiPageEnabled', 'annotationTypes', 'disableCommentCreation', 'filterComments', 'globalCommentsUnmapped', 'imageCapture', 'imageContextData', 'locale', 'pollForUpdates', 'reCaptchaSiteKey', 'reCaptchaEnabled', 'touchControls', 'typekitId'];

var useAppState = function useAppState(props) {
  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      asset = _useState2[0],
      setAsset = _useState2[1];

  var assetData = (0, _useAssetData.default)(props.assetData, props.annotationsMultiPageEnabled);
  var imsData = (0, _useIMSData.default)(props.imsData);
  var isOffline = (0, _useOfflineStatus.default)();
  var globalCommentsToggle = (0, _useGlobalCommentsToggle.default)(props.annotationsMultiPageEnabled);
  var capabilities = (0, _useCapabilities.default)(assetData.id, props.appKey, props.environment, props.invitationServiceAccessToken, imsData);
  var appState = {
    assetData: assetData,
    imsData: imsData,
    isOffline: isOffline,
    capabilities: capabilities,
    globalCommentsToggle: globalCommentsToggle,
    mentionsEnabled: props.mentionsEnabled && !imsData.isGuestUser,
    asset: {
      asset: asset,
      setAsset: setAsset
    }
  };
  appContextKeys.forEach(function (key) {
    return appState[key] = props[key];
  });

  if (props.privateLink === false && appState.shareStatus !== 'public') {
    appState.shareStatus = 'public';
  }

  var previousAppState = (0, _usePrevious.default)(appState); // Return previousAppState to reduce rerenders.

  return (0, _lodash.default)(previousAppState, appState) ? previousAppState : appState;
};

var _default = useAppState;
exports.default = _default;